export var BtcdirectOrderStatus;
(function (BtcdirectOrderStatus) {
    BtcdirectOrderStatus["PENDING"] = "PENDING";
    BtcdirectOrderStatus["QUOTE_CONFIRMED"] = "QUOTE_CONFIRMED";
    BtcdirectOrderStatus["ADDRESS_VALIDATED"] = "ADDRESS_VALIDATED";
    BtcdirectOrderStatus["CRYPTO_TRANSACTION_INITIATED"] = "CRYPTO_TRANSACTION_INITIATED";
    BtcdirectOrderStatus["TRANSACTION_CONFIRMED"] = "TRANSACTION_CONFIRMED";
    BtcdirectOrderStatus["HASH_SUBMITTED"] = "HASH_SUBMITTED";
    BtcdirectOrderStatus["COMPLETED"] = "COMPLETED";
    BtcdirectOrderStatus["FAILED"] = "FAILED";
})(BtcdirectOrderStatus || (BtcdirectOrderStatus = {}));
export var BtcdirectUserStatusCode;
(function (BtcdirectUserStatusCode) {
    BtcdirectUserStatusCode["NOT_REGISTERED"] = "NOT_REGISTERED";
    BtcdirectUserStatusCode["NOT_LINKED"] = "NOT_LINKED";
    BtcdirectUserStatusCode["LINKED"] = "LINKED";
})(BtcdirectUserStatusCode || (BtcdirectUserStatusCode = {}));
//# sourceMappingURL=btcdirect.types.js.map